
import AxiosApiClient from './AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';

import $ from 'jquery'; // Import jQuery

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

const initialOrganizationInput = {
    random_id: '',
    name: '',
    slug: '',
    billing_contact: '',
    billing_email: '',
    app: process.env.REACT_APP_NAME,
    errorList: [],
    errorStyle: [],
};

// helper for API backend selection
const getAuthApi = () => {
    return localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== ''
        ? localStorage.getItem('auth_api')
        : 'phpLaravel';
};

export const saveOrganization = (event, { organizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal }) => {
    if (event) event.preventDefault();

    setIsLoading(true);

    // Create FormData instance
    const formData = new FormData();

    appendIfNotNull(formData, 'name', organizationInput.name);
    appendIfNotNull(formData, 'billing_contact', organizationInput.billing_contact);
    appendIfNotNull(formData, 'billing_email', organizationInput.billing_email);
    appendIfNotNull(formData, 'billing_address', organizationInput.billing_address);
    appendIfNotNull(formData, 'billing_city', organizationInput.billing_city);
    appendIfNotNull(formData, 'billing_state', organizationInput.billing_state);
    appendIfNotNull(formData, 'billing_zip', organizationInput.billing_zip);
    appendIfNotNull(formData, 'app', organizationInput.app);

    if (organizationInput.random_id) {
        appendIfNotNull(formData, 'random_id', organizationInput.random_id);
        formData.append('mode', 'edit');
    }

    const fetchApiDataSaveOrganization = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('post', '/api/save_organization', formData, {
                params: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                },
            });

            setApiDataSaveOrganization(response, "OrganizationService", { organizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal });
        } catch (error) {
            handleApiErrorSaveOrganization(error, "OrganizationService", { setViewMode, setIsLoading, navHistory, swal });
        }
    };

    fetchApiDataSaveOrganization();
};

function setApiDataSaveOrganization(response, theFunction, { organizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal }) {
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);

            AuthUtility.setOrganizationData(response.data.organization);

            setOrganizationInput(initialOrganizationInput);

            setViewMode('view_account');
            swal("Info", response.data.message, "info");
        } else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            //user not authenticated on server so remove from local storage
            AuthUtility.clearAuthData();
            AuthUtility.clearOrganizationData();
            
            setIsLoading(false);
            navHistory('/login');
        } else if (response.data.status === 404) {//HTTP_NOT_FOUND
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
            console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

            var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
            Object.keys(errorStyleTemp).map((key) => (
                errorStyleTemp[key] = error_style
            ));
            Object.keys(errorStyleTemp).map((key) => (
                $('#' + key + '_message').addClass('hide') //clear any previous message
            ));

            //validation errors mapped to input fields
            setOrganizationInput({ ...organizationInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });
        } else {//more errors
        }
    }

    setIsLoading(false);
}

function handleApiErrorSaveOrganization(error, theFunction, { setIsLoading, navHistory, swal }) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    AuthUtility.clearAuthData();
    AuthUtility.clearOrganizationData();

    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/login');
}

export function deleteOrganization(event, { tempOrganizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal }){
    if (event) event.preventDefault();

    setIsLoading(true);

    if (tempOrganizationInput.random_id && tempOrganizationInput.random_id === '' && tempOrganizationInput.app && tempOrganizationInput.app === '') {
        setIsLoading(false);
        return;
    }

    const fetchApiDataDeleteOrganization = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('delete', '/api/delete_organization/'+tempOrganizationInput.app+'/'+tempOrganizationInput.random_id, null, {
                params: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                },
            });

            setApiDataDeleteOrganization(response, "OrganizationService", { setOrganizationInput, setViewMode, setIsLoading, navHistory, swal });
        } catch (error) {
            handleApiErrorDeleteOrganization(error, "OrganizationService", { setViewMode, setIsLoading, navHistory, swal });
        }
    };

    fetchApiDataDeleteOrganization();
};

function setApiDataDeleteOrganization(response, theFunction, { setOrganizationInput, setViewMode, setIsLoading, navHistory, swal }) {
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);

            AuthUtility.clearOrganizationData();

			setOrganizationInput(initialOrganizationInput);

            setViewMode('view_account');
            swal("Info", response.data.message, "info");
        } else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            //user not authenticated on server so remove from local storage
            AuthUtility.clearAuthData();
            AuthUtility.clearOrganizationData();
            
            setIsLoading(false);
            navHistory('/login');
        } else if (response.data.status === 404) {//HTTP_NOT_FOUND
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
            console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');
        } else {//more errors
        }
    }

    setIsLoading(false);
}

function handleApiErrorDeleteOrganization(error, theFunction, { setIsLoading, navHistory, swal }) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    AuthUtility.clearAuthData();
    AuthUtility.clearOrganizationData();

    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/login');
}

// Helper function
const appendIfNotNull = (formData, key, value) => {
    if (value !== null && value !== undefined && value !== "null") {
        formData.append(key, value);
    } else {
        formData.append(key, ''); // or skip if your backend interprets missing fields as null
    }
};